import React from 'react';
import { Image, View } from 'react-native';
import { Button, DefaultScreenContainer, Text } from '~/components';
import Benefit from './components/Benefit';

import CardExample from '~/assets/img/marisa-card-example.png';
import DoubleCardExample from '~/assets/img/double-card-example.png';

import CardLogoSVG from '~/assets/svgs/logo-cartao-marisa.svg';
import CreditCardSVG from '~/assets/svgs/credit-card-bg.svg';
import PercentSVG from '~/assets/svgs/percent-bg.svg';
import { MarisaAppUtils } from '~/utils/MarisaAppUtils';
import { getFormattedLinkToBrowser } from '~/utils/url';
import ContactCard from './components/ContactCard';
import useAppNavigation from '~/hooks/useAppNavigation';
import useCredsystemAuthStore from '~/credsystem/stores/credsystemAuth';

const AboutMarisaCard: React.FC = () => {
  const { navigate } = useAppNavigation();
  const handleOpenCredsystem = () => {
    if (MarisaAppUtils.origin !== 'app') {
      if (!useCredsystemAuthStore.getState().credsystemUserInfo) {
        return navigate('Credsystem_SignIn');
      }

      return navigate('Credsystem_Dashboard');
    } else {
      return MarisaAppUtils.goToMbank();
    }
  };

  return (
    <DefaultScreenContainer>
      <View className="bg-[#EEEEEE] pt-10 pb-6 px-4 md:flex-row md:items-center md:justify-center">
        <View className="md:w-[50%]">
          <View className="w-full">
            <CardLogoSVG />
          </View>

          <Text className="text-lg text-gray-500 font-light text-left mb-10">
            Faça já o seu em uma loja Marisa perto de você e aproveite todas as
            vantagens!
          </Text>
        </View>

        <View className="items-center justify-center">
          <Image
            source={CardExample}
            className={`w-[327px] h-[199px] lg:w-[404px] lg:h-[247px]`}
          />
        </View>
      </View>

      <View className="px-0 sm:px-12">
        <View className="px-4 py-10 items-center justify-center">
          <Text className="text-xl text-gray-700 text-center mb-10">
            Desfrute de todos os benefícios do{' '}
            <Text className="font-medium text-primary-600">Cartão Marisa</Text>
          </Text>

          <View className="sm:flex-row sm:items-center sm:justify-between">
            <Benefit
              icon={CreditCardSVG}
              description="Parcelar suas compras em até 5x sem juros ou em até 8x com
            acréscimos com 60 dias para pagar"
            />

            <Benefit
              icon={PercentSVG}
              description="10% de desconto em sua primeira compra"
            />

            <Benefit
              icon={PercentSVG}
              description="10% de desconto em uma compra no mês do seu aniversário"
            />
          </View>
        </View>

        <View className="bg-primary-500 px-10 py-2 sm:py-5 mb-8">
          <Text className="text-lg text-light-100 text-center">
            Quer acessar o seu cartão Marisa agora?{' '}
            <Text className="font-medium" onPress={handleOpenCredsystem}>
              Clique Aqui
            </Text>
          </Text>
        </View>

        <View className="bg-[#F7F7F7] pt-10 pb-2 px-12 md:flex-row items-center justify-center md:justify-between">
          <View className="md:w-[50%]">
            <Text className="text-[30px]">
              Acesse o contrato do{' '}
              <Text className="font-medium text-primary-600">
                Cartão Marisa
              </Text>
            </Text>
            <Button
              variant="secondary"
              className="py-2 px-4 rounded-md mt-5 bg-transparent border-primary-600 md:mr-auto self-center"
              onPress={() =>
                MarisaAppUtils.openUrl(
                  getFormattedLinkToBrowser(
                    'https://psffiles.blob.core.windows.net/psfcontratos/contratos/credsystem/contrato.pdf'
                  )
                )
              }
            >
              VER CONTRATO
            </Button>
          </View>

          <Image
            source={DoubleCardExample}
            className={`w-[328px] h-[230px] lg:w-[426px] lg:h-[300px]`}
          />
        </View>

        <Text className="mt-8 mb-6 font-medium text-gray-400 text-base text-center">
          SAC CARTÕES MARISA
        </Text>

        <View className="px-6 sm:px-0 sm:flex-row sm:items-center sm:space-x-4">
          <ContactCard
            title="Telefone"
            children={
              <>
                <Text className="text-gray-400 text-xs">
                  Capitais e regiões metropolitanas:
                </Text>
                <Text className="text-primary-600 text-xs font-medium">
                  4003-3900
                </Text>
                <Text className="text-gray-400 text-xs">
                  Demais:{' '}
                  <Text className="text-primary-600 text-xs font-medium">
                    0800-729-3900
                  </Text>
                </Text>
              </>
            }
          />

          <ContactCard
            title="Ouvidoria"
            children={
              <>
                <Text className="text-primary-600 text-xs font-medium">
                  0800-777-5297
                </Text>
                <Text className="text-gray-400 text-xs">
                  Segunda à sábado das 8h às 22h
                </Text>
                <Text className="text-gray-400 text-xs">
                  Domingo e feriados das 9h às 20h
                </Text>
              </>
            }
          />
        </View>
      </View>
    </DefaultScreenContainer>
  );
};

export default AboutMarisaCard;
